<template>
  <div :class="['tooltip-wrapper', className]" style="display: inline-block">
    <div ref="tooltipTrigger">
      <slot name="trigger"></slot>
    </div>
    <div ref="content" :style="{ maxWidth: calculatedWidth }">
      <slot v-if="!disabled" name="tooltip"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placement: {
      type: String,
      default: "left"
    },
    options: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ""
    },
    width: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      tippyRef: null
    };
  },
  computed: {
    calculatedWidth() {
      return this.width !== null ? `${this.width}px` : undefined;
    }
  },
  watch: {
    disabled(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          // Turn off tooltip
          this.tippyRef.destroy();
        } else {
          this.initTooltip();
        }
      }
    }
  },
  mounted() {
    if (!this.disabled) {
      this.initTooltip();
    }
  },
  methods: {
    initTooltip() {
      this.tippyRef = tippy(this.$refs.tooltipTrigger, {
        appendTo: document.body,
        content: this.$refs.content,
        interactive: true,
        delay: [300, 300],
        placement: this.placement,
        hideOnClick: false,
        arrow: true,
        ...this.options,
        theme: this.options.theme || this.className
      });
    }
  }
};
</script>

<style lang="scss">
.tippy-tooltip {
  padding: 10px;
  .tippy-content {
    box-shadow: none !important;
    border: none;
    color: var(--white) !important;
  }
}

@media (min-width: 852px) {
  .tippy-tooltip {
    max-width: none !important;
  }
}
</style>
